import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { PostHogProvider } from 'posthog-js/react';
import { App } from './App';
const options = {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
};
render(<PostHogProvider apiKey="phc_7T4n6Q8FmVZqf4bhHzL9wW9YseVXBCeiicm2cQB3rEv" options={options} data-id="element-231">
    <App data-id="element-232" />
  </PostHogProvider>, document.getElementById('root'));